import styled from "styled-components";

import { themes } from "@olist/design-system-tokens";

export const FooterWrapper = styled.footer`
  background-color: ${themes.olist.base.color.primary.base};
  bottom: 0;
  min-height: 64px;
  position: relative;
  width: 100%;
`;
